import getConfig from 'next/config'

const cdnBasePath = getConfig().publicRuntimeConfig.cdnBasePath
const cdnImages = getConfig().publicRuntimeConfig.cdnImages
const previewImagePath = getConfig().publicRuntimeConfig.previewImagePath

export const iconPath = (url: string) =>
  url.startsWith('https://') ? url : `${cdnBasePath}/${cdnImages}/${url}`
export const imagePath = (url: string) =>
  url.startsWith('https://') ? url : `${cdnBasePath}/${url}`

export const previewImage = (path = '') =>
  path.startsWith('https://') ? path : `${previewImagePath}${path}`
